<mat-toolbar class="titulopartes">Escolaridade</mat-toolbar>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <combo-grau-instrucao fxFlex="50%" fxFlexOffset="20px"
                           [selecionado]="pessoaFisica.grausInstrucao"
                           [obrigatorio]="false"
                           (valorChange)="onGrauInstrucaoChange($event)">
    </combo-grau-instrucao>
</div>



